import React, {useEffect} from 'react';
import {useMsal} from '@azure/msal-react';

const UserNotFound = () => {
  const {instance} = useMsal();

  useEffect(() => {
    instance.logoutRedirect();
  }, []);

  return <div>Please wait...</div>;
};

export default UserNotFound;
